<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="companyName">Company Name</label>
              <input
                type="text"
                name="companyName"
                placeholder="Company Name"
                class="form-control"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="industry">Industry</label>
              <input
                type="text"
                name="industry"
                placeholder="Industry"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="companyEmail">Company Email</label>
              <input
                type="text"
                name="companyEmail"
                placeholder="Company Email"
                class="form-control"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="contactNumber">Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                placeholder="Contact number"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="officeType">Office</label>
              <v-select :options="officeTypes" name="officeType" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="location">Location</label>
              <v-select :options="locations" name="location" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                label="Create"
                :theme="{ primary, secondary, event, danger }"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";

export default {
  name: "AddNewCompany",
  components: {
    ActionButton
  },
  data() {
    return {
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      selectedUserRole: "Member",
      officeTypes: ["Sample Office Type", "Sample Office Type 1"],
      selectedCompany: "Sample Company",
      locations: ["Sample Location", "Sample Location 2"],
      isToggled: false
    };
  },
  methods: {
    handleTogglePasswordClick() {
      this.isToggled = !this.isToggled;
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss"></style>
